module.exports = __webpack_public_path__ + "img/new.712a282a.svg";